import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { SiteContentProvider } from "@/context/SiteContentContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudy from "@/pages/CaseStudy";
import Legal from "@/pages/Legal";
import Careers from "@/pages/Careers";
import ROICalculator from "@/pages/ROICalculator";
import Resources from "@/pages/Resources";
import Gallery from "@/pages/Gallery";
import ServiceDetail from "@/pages/ServiceDetail";
import ProjectDetail from "@/pages/ProjectDetail";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_ID;
    if (gaId && !window.__gaLoaded) {
      window.__gaLoaded = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", gaId);
    }
  }, []);

  return (
    <LanguageProvider>
      <SiteContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/:slug" element={<CaseStudy />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/roi-calculator" element={<ROICalculator />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/privacy" element={<Legal type="privacy" />} />
            <Route path="/terms" element={<Legal type="terms" />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </SiteContentProvider>
      <Toaster position="top-center" theme="dark" richColors />
    </LanguageProvider>
  );
}

export default App;
